export enum ReturnDetailTab {
  Client = 'client',
  Return = 'return',
}
